import type { CertificatesKpisVesselTypesSelectorProps } from "../../models/admin-kpis.models";
import AdminKpisMultiSelectFilter from "./AdminKpisMultiSelectFilter";
import { memo } from "react";

const CertificatesKpisVesselTypesSelector = ({
  value,
  options,
  loading,
  onChange,
}: CertificatesKpisVesselTypesSelectorProps) => (
  <AdminKpisMultiSelectFilter
    label="Vessel Types"
    options={options}
    value={value}
    dataTest="admin-kpis-source-vessel-types"
    disabled={loading || options.length === 0}
    className="w-44 max-w-full"
    onChange={onChange}
  />
);

export default memo(CertificatesKpisVesselTypesSelector);
